<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>{{ 'Card Information' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()" fill="clear">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div class="inner-content">

  <div class="bg-light chip-row">
    <span class="chip" (click)="openCustomDiscountModal()">{{ '+ Add Discount' | translate }}</span>
    <span class="chip" (click)="removeCents()">{{ 'Remove Cents' | translate }}</span>
  </div>

  <div class="note">
   <ion-note color="warning">{{ 'Please ensure that any discounts or adjustments are applied before entering the card information. Once card details are entered, no further changes can be made to the total amount.' | translate }}</ion-note>
 </div>
 
  <ng-container *ngIf="stripeTest">
    <form [formGroup]="stripeTest" class="pt-3">
      <ion-item class="mb-3 bg-light">
        <ion-label position="stacked">{{ 'Card Holder Name' | translate }}</ion-label>
        <ion-input
          [placeholder]="'John Doe' | translate"
          formControlName="name"
          autocomplete="off"></ion-input>
        <ion-icon
          class="white-icon ion-padding-top"
          size="small"
          slot="end"
          name="person"></ion-icon>
      </ion-item>
      <ion-text color="danger" *ngIf="stripeTest.get('name').invalid && stripeTest.get('name').touched">{{ 'Card Holder Name is required.' | translate }}</ion-text>
    </form>
  </ng-container>

  <div class="px-3" *ngIf="publicKeyForFirstTranscation">
    <ngx-stripe-card [options]="cardOptions" [elementsOptions]="elementsOptions"></ngx-stripe-card>
  </div>
</div>

<ion-footer class="px-3 py-2">
  <ion-button
    fill="solid"
    expand="block"
    type="submit"
    [disabled]="stripeTest?.status === 'INVALID' || disablePayButton || fetching"
    (click)="buy()">
    <ng-container *ngIf="!fetching">
      <span>{{ 'Pay Securely' | translate }}</span>{{ '&nbsp;' | translate }}<span>
        {{ data?.totalAmount | currency: basicInfo?.currencyCode }}
      </span>
    </ng-container>
    <ion-spinner *ngIf="fetching" name="crescent"></ion-spinner>
  </ion-button>
</ion-footer>
